import React, { Children, Fragment, useEffect, useRef, useState } from "react";
import useSocket, { SocketInvoke } from "../../_services/socket";
import { TextBoxTypeEnum } from "../../enums/TextBoxTypeEnum";
import { Button, Icon, RaytebForm, TextBox } from "../../share/Elements";
import useFetch from "../../_services/fetch";
import { RaytebRequests } from "../../_services";
import LoadingFit from "../../share/Components/Loading/LoadingFit";
import { File, Photo, Audio, RaytebModal, Message, Voice } from "../../share/Components";
import { useSearchParams } from "react-router-dom";
import { useAudioRecorder } from "react-audio-voice-recorder";
import { toast } from "react-toastify";
import Debounce from "../../share/Elements/Textboxs/Debounce";
import { ChatStatusEnum } from "../../enums/ChatStatusEnum";

type ChatSettingType = {
    users: { position: 'right' | 'left', clientId: string }[],
    positionBots: 'right' | 'left'
}
const Chat = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const accessToken = searchParams.get('token')!;
    const clientId = searchParams.get('clientId')!;
    const showSenderName = (searchParams.get('showSenderName') == 'true');
    const showHistory = searchParams.get('showHistory') == 'true';
    const validationParam = searchParams.get('validation');
    const settingChat = searchParams.get('settingChat')
    const settingChatJson = settingChat ? JSON.parse(searchParams.get('settingChat')!) as unknown as ChatSettingType | undefined : null
    const validationJSON = validationParam ? JSON.parse(searchParams.get('validation')!) as unknown as Array<ValidationType> : undefined;
    const [validation, setValidation] = useState<Array<ValidationType> | undefined>(validationJSON);
    const chatListElement = useRef<HTMLDivElement>(null)
    const [token, setToken] = useState<string>(accessToken)
    const [uploadLocal, setUploadLocal] = useState<Array<UplaodInterface>>([]);
    const [messages, setMessages] = useState<Array<UserChatMessageViewModel>>([])
    const [status, setStatus] = useState<ChatStatusEnum>();
    const requestGetToken = useFetch<{ accessToken: string }, { accessToken: string }>({
        request: RaytebRequests.ChatRoom_GetToken(),
        onSuccess(data) {
            setToken(data.accessToken)
        },
    })
    const isLeftPosition = (senderId: string, isBot: boolean): boolean => {
        if (settingChatJson && settingChatJson.users && !isBot) {
            if (settingChatJson?.users?.find(x => x.clientId === senderId)?.position === 'left')
                return true
            else
                return false
        }
        else if (settingChatJson && isBot)
            return settingChatJson.positionBots === 'left'
        else
            return isBot || senderId !== clientId
    }
    const getMessages = useFetch<Array<UserChatMessageViewModel>>({
        request: showHistory ? RaytebRequests.ChatRoom_GetMessageChatGroup(token) : RaytebRequests.ChatRoom_GetMessage(token),
        onSuccess(data) {
            setMessages(data)
            //goBottomChat()
            setTimeout(() => {
                goToFirstUnReadMessage(data)
            }, 700);
            HandleValidation(validation, setValidation, { users: data, userId: clientId })
        },
        onError(data) {

        },
        onStatusCode400(data) {

        },
    })
    const getUser = useFetch<{ permissions: string[] }>({
        request: RaytebRequests.ChatRoom_GetUser(token),
        onError(data) {

        },
        onStatusCode400(data) {

        }
    })
    const getStatus = useFetch<ChatStatusViewModel>({
        request: RaytebRequests.ChatRoom_GetChatStatus(token),
        onError(data) {

        },
        onStatusCode400(data) {

        },
        onSuccess(data) {
            setStatus(data.status)
        },
    })
    const socket = useSocket({
        controllerName: 'chatRoom',
        ReciveMethods: {
            methods: [{
                name: 'SeenMessage',
                onRecived(data) {
                    var findIndex = messages.findIndex(x => x.message.id == data.messageId)
                    if (findIndex != -1) {
                        const copyMessages = [...messages]
                        copyMessages.forEach((item) => {
                            if (item.message.id <= data.messageId)
                                item.message.isSeen = true
                        })
                        setMessages(copyMessages)
                    }
                },
            },
            {
                name: 'SandBox',
                onRecived(data) {
                    const msg = data as UserChatMessageViewModel
                    if (msg.message.attaches && msg.message.attaches.length !== 0) {
                        const files = [...uploadLocal].filter(x => !x.files.some((a, i) => a.name === x.files[i].name && a.type === x.files[i].type))
                        setUploadLocal(files)
                    }
                    setMessages((prevArr) => [...prevArr, msg])
                    if (msg.senderId === clientId)
                        goBottomChat()
                    else if (chatListElement.current?.scrollTop! >= chatListElement.current?.scrollHeight! - chatListElement.current?.clientHeight!)
                        goBottomChat()


                },
            },
            {
                name:"SyncNewStatus",
                onRecived(data) {
                    const model = data as ChatStatusViewModel
                    setStatus(model.status)
                },
            }
            ],
            dependencies: [messages,status]
        }
        ,
        token: token,
        onError(err) {
            if (token)
                requestGetToken.reFetch({ accessToken: token })
        },
    })
    const checkAndUpdateMessage = (messages: UserChatMessageViewModel[]) => {
        Debounce({
            func: () => {
                const seenMessages = Array.from(chatListElement.current?.children!)
                    .filter(x => x.getBoundingClientRect().top <= chatListElement.current?.offsetHeight!
                        && x.getBoundingClientRect().top >= 0).map(x => parseInt(x.id)); // آیدی هایی که خونده میشه
                const messagesParam = messages
                    .filter(x => seenMessages.includes(x.message.id) && !x.message.isSeen && !x.isBot && x.senderId != clientId) //ایدی هایی که باید سین بشن
                if (messagesParam.length !== 0)
                    socket.Invoke?.('SeenMessage', { messageId: messagesParam[messagesParam.length - 1]?.message.id });
            },
            timeout: 200
        })
    }
    const goBottomChat = () => {
        const scrollHeight = chatListElement.current?.scrollHeight! - chatListElement.current?.scrollTop!
        if ((scrollHeight! + 200) >= chatListElement.current?.offsetHeight!)
            setTimeout(() => {
                chatListElement.current?.scroll({
                    top: chatListElement.current?.scrollHeight,
                    behavior: "smooth"
                })
            }, 200);
    }
    const goToFirstUnReadMessage = (data: Array<UserChatMessageViewModel>) => {
        const messageUnRead = data.find(x => x.senderId != clientId && !x.message.isSeen && !x.isBot)
        if (messageUnRead)
            document.getElementById(messageUnRead?.message.id.toString() ?? '')?.scrollIntoView();
        else
            goBottomChat()
    }
    useEffect(() => {
        if (token) {
            getMessages.reFetch()
            getUser.reFetch()
            getStatus.reFetch()
        }
    }, [token])
    useEffect(() => {
        chatListElement.current?.removeEventListener('scroll', () => checkAndUpdateMessage(messages))
        chatListElement.current?.addEventListener('scroll', () => checkAndUpdateMessage(messages))
    }, [messages])
    useEffect(() => {
        checkAndUpdateMessage(messages)
    }, [socket])

    return <>
        <div className={`w-full h-full  mx-auto shadow-lg  overflow-hidden absolute
         flex justify-center items-center flex-col gap-3 bg-[url('./assert/images/chat-background.png')]`}>
            <LoadingFit isLoading={requestGetToken.isLoading || getMessages.isLoading} />

            <div className="w-full h-full overflow-y-auto z-10 p-2 flex flex-col gap-2 scroll-smooth" ref={chatListElement}>
                {messages.map((x) => <Message key={x.message.id}
                    id={x.message.id}
                    user={x}
                    showSenderName={showSenderName}
                    position={isLeftPosition(x.senderId, x.isBot) ? 'left' : 'right'}
                    className={`${isLeftPosition(x.senderId, x.isBot) ? '!bg-white' : ' !bg-[#f2f9ff]'} `}
                />)}
                {uploadLocal.map((x, i) => <Message key={i}
                    showSenderName={showSenderName}
                    user={{
                        senderId: 'local',
                        senderName: 'ارسال فایل',
                        isBot: false,
                        message: {
                            text: '', insertDate: new Date(),
                            attaches: x.files.map(file => { return { fileAddress: file.fileAddress!, fileExtension: file.type, name: file.name, isLoading: file.Status === 'Sending' || file.Status === 'Selected' } }),
                            id: i,
                            isSeen: false
                        }
                    }} position={'right'}
                    className={`!bg-[#f2f9ff]`}
                />)}
            </div>
            <SendBox
               status={status}
                validation={validation}
                setValidation={setValidation}
                socket={socket}
                onUploadLocal={(file) => {
                    setUploadLocal([...uploadLocal, file])
                    setTimeout(() => {
                        goBottomChat()
                    }, 300);
                }}
            />
        </div>
    </>
}

const SendBox = ({ socket, validation, setValidation, onUploadLocal,status }: {
    socket: SocketInvoke
    validation?: Array<ValidationType>
    onUploadLocal?: (file: UplaodInterface) => void
    setValidation: React.Dispatch<React.SetStateAction<ValidationType[] | undefined>>
    status?: ChatStatusEnum
}) => {
    // const [fileModal, setFileModal] = useState<FileModalInterface>({ isOpen: false })
    const fileElement = useRef<HTMLInputElement>(null)
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [voiceAddress, setVoiceAddress] = useState<string | undefined>()
    const isValid = !validation || validation?.filter(x => !x.isPass).length === 0
    const uploadVoiceRequest = useFetch<string, FormData>({
        request: RaytebRequests.ChatRoom_UploadFile(),
        onSuccess(data) {
            setIsLoading(true)
            socket.Invoke!('SendMessageUser', {
                Text: '', Attachments: [{ FileAddress: data, Size: 0, FileName: '', FileExtension: 'audio/webm' }]
            }).then(function (res) {
                setVoiceAddress(undefined)
                setIsLoading(false)
            })
        },
        order: 1
    })

    const uploadFileRequest = useFetch<string, FormData>({
        request: RaytebRequests.ChatRoom_UploadFile(),
        onSuccess(data) {
            const files = [...uploadFile]
            files.forEach(x => {
                x.files.forEach(file => {
                    if (file === uploadFileRequest.payLoad?.get(`file.${file.name.split('.')[1]}`)) {
                        file.Status = 'IsSend'
                        file.fileAddress = data
                    }
                })
            })

            setUploadFile(files);
        },
    })

    const recorderControls = useAudioRecorder({
        noiseSuppression: false,
        echoCancellation: false,
    }, (ex) => toast.error('لطفا دسترسی میکروفون را فعال کنید', { position: 'top-center' }))
    const [uploadFile, setUploadFile] = useState<Array<UplaodInterface>>([]);
    const [text, setText] = useState<string>('');
    useEffect(() => {
        if (uploadFile.length > 0) {
            if (uploadFile.filter(a => a.files.some(x => x.Status === 'Sending'))?.length === 0 && uploadFile.some(a => a.files.some(x => x.Status === 'Selected'))) {
                const files = [...uploadFile]
                // files.forEach(x => {

                // })
                for (let index = 0; index < files.length; index++) {
                    const fileUplaods = files[index]
                    var fileIndex = fileUplaods.files.findIndex(x => x.Status === 'Selected');
                    if (fileIndex === -1)
                        continue;
                    fileUplaods.files[fileIndex].Status = 'Sending';
                    var formData = new FormData();
                    formData.append(`file.${fileUplaods.files[fileIndex].name.split('.')[1]}`, fileUplaods.files[fileIndex]);
                    uploadFileRequest.reFetch(formData)
                    break;

                }
                setUploadFile(files)
                return
            }

            setIsLoading(true)
            var files = [...uploadFile]
            var indexFileSent = 0;
            while (files.length !== 0) {
                const current = files[indexFileSent];
                if (!current)
                    break;
                const sendFile = async (fileMessage: FileUploadType[]) => {
                    var uploads = files.filter(x => !x.files.some((x, i) => x.name === current.files[i].name))
                    files = uploads
                    setUploadFile(files)
                    await socket.Invoke!('SendMessageUser', {
                        Text: '', Attachments: fileMessage.map(x => { return { FileAddress: x.fileAddress, Size: x.size, FileName: x.name, FileExtension: x.type } })
                    })
                }
                if (!current.files.some(a => a.Status === 'Selected' || a.Status === 'Sending')) {
                    sendFile(current.files)
                }
                else {
                    files = files.filter((x, i) => i !== indexFileSent)
                }
                indexFileSent++;
            }
            setIsLoading(false)
            // for (var i = 0; i < uploadFile.length; i++) {
            //     const files = uploadFile[i];
            //     if (!files.files.some(a => a.Status === 'Selected' || a.Status === 'Sending')) {
            //         socket.Invoke!('SendMessageUser', {
            //             Text: '', Attachments: files.files.map(x => { return { FileAddress: x.fileAddress, Size: x.size, FileName: x.name, FileExtension: x.type } })
            //         }).then(function (res) {
            //             setText('')
            //             var uploads = [...uploadFile].filter(x => !x.files.some((x, i) => x.name === files.files[i].name))
            //             setUploadFile(uploads)
            //             setIsLoading(false)
            //         }).catch(function (ex) {
            //             onError()
            //         })
            //     }
            // }
        }
    }, [uploadFile])
    useEffect(() => {
        if (!recorderControls.recordingBlob)
            return;

        const url = URL.createObjectURL(recorderControls.recordingBlob!)
        setVoiceAddress(url);
    }, [recorderControls.recordingBlob])

    return <>
        <input type="file" className="hidden" multiple ref={fileElement} onChange={(e) => {
            if (e.target.files && e.target.files.length !== 0) {
                const files: UplaodInterface = {
                    caption: '',
                    files: Array(...e.target.files)!.map((x) => {
                        var file = x as FileUploadType;
                        file.fileAddress = URL.createObjectURL(x)
                        file.Status = 'Selected'
                        return file;
                    })

                };
                setUploadFile([...uploadFile, files])
                onUploadLocal?.(files)
                // setFileModal({ ...fileModal, isOpen: false, files: undefined })
            }
            // setFileModal({ ...fileModal, isOpen: true, files: Array(...e.target.files) })
        }} />
        <GetComponentValidation props={text} param={validation?.[0]} setState={setValidation} validations={validation} />
        <RaytebForm className="bg-white z-10 flex justify-between  items-center w-full px-2 relative" onSubmit={(data) => {
            // if (isLoading)
            //     return;
            if (!isValid) {
                toast.error('دیتا معتبر نمیباشد لطفا شرط نیازمندی ها را رعایت کنید')
                return;
            }
            else
                setValidation([])
            if (voiceAddress && recorderControls.recordingBlob) {
                var formData = new FormData();
                formData.append('voice.webm', new window.File([recorderControls.recordingBlob], 'voice.webm', {
                    type: recorderControls.recordingBlob.type
                }));
                uploadVoiceRequest.reFetch(formData)
                setVoiceAddress(undefined)
            }
            else {
                const text = data.target['message']?.value;
                if (text.length < 1)
                    return;
                setIsLoading(true)
                socket.Invoke!('SendMessageUser', { Text: text }).then(function (res) {
                    setText('')
                    setIsLoading(false)
                })
            }
        }}>             
           {status === ChatStatusEnum.Pause &&
                 <p className="absolute left-[50%] text-xs bg-disable text-primaryLight font-bold
                  px-2 py-0.5 rounded-xl -top-7 translate-x-[-50%] border-[1px] border-dangerLight whitespace-nowrap">چت بسته شده و امکان ارسال پیام وجود ندارد</p>}

            {!voiceAddress ? <div className={`${text.length > 0 ? '' : ''} w-full`}>
                <TextBox disabled={status === ChatStatusEnum.Pause} className="h-12 !text-sm rounded-none !border-none !outline-none !ring-0  rounded-tr-2xl" debounceTime={0} name="message" Type={TextBoxTypeEnum.Text} innerText="پیام"
                    onChange={(e) => setText(e.target.value)}
                    value={text}
                />

            </div> : voiceAddress ? <div className=" w-full flex px-2">
                <Icon icon="rayteb-delete" className="text-danger text-2xl" onClick={() => setVoiceAddress(undefined)} />
                <Voice fileAddress={voiceAddress} fileName="" className="w-full  p-0" />
            </div> : <></>}


            <Button disabled={status === ChatStatusEnum.Pause} type="submit" /*disabled={isLoading}*/ className={`!rounded-tl-2xl   h-10  w-10  !p-0 !bg-white !border-none col-span-1 
                ${!isValid && 'hidden'} text-primaryLight ${(text.length < 1 && !voiceAddress) && 'hidden'}`}>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={3} stroke="currentColor" className="w-[75%] h-[75%] transform rotate-180 ">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5" />
                </svg>
            </Button>
            <div className={`${(text.length > 0 || voiceAddress) && 'hidden'}  bg-white flex justify-center items-center rounded-tl-2xl`}>
                <Icon disabled={status === ChatStatusEnum.Pause} icon="rayteb-attach" className={`w-12 h-12 text-2xl text-[#7da1c7] ${!isValid && 'text-disable'}`} onClick={() => { isValid && fileElement.current?.click() }} />
                <a
                    className={`${!isValid || status === ChatStatusEnum.Pause ? 'text-disable' : ''} `}
                    onMouseDown={() => { isValid && recorderControls.startRecording() }}
                    onMouseUp={() => { isValid && recorderControls.stopRecording() }}
                    onTouchStart={() => { isValid && recorderControls.startRecording() }}
                    onTouchEnd={() => { isValid && recorderControls.stopRecording() }}

                >
                    <Icon disabled={status === ChatStatusEnum.Pause} icon="rayteb-microphone" className={`w-11 h-11 text-2xl ${recorderControls.isRecording ? '!text-red-600' : '!text-white'}  rounded-full  bg-primary `} />
                </a>
                {/* <AudioRecorder
                    classes={{
                        AudioRecorderClass: ''
                    }}
                    onRecordingComplete={voiceRecorderEnded}
                    recorderControls={recorderControls}
                /> */}
            </div>



        </RaytebForm >
        {/* <RaytebModal {...fileModal} className={'p-2 rounded-lg !overflow-hidden max-w-[420px]'} hideModal={() => {
            setFileModal({ ...fileModal, isOpen: false, files: undefined })
            fileElement.current!.value = ''
        }}>
            <RaytebForm className="w-full" onSubmit={(e) => {
                setUploadFile([...uploadFile, {
                    caption: e.target['caption'].value,
                    files: fileModal.files!.map((x) => {
                        var file = x as FileUploadType;
                        file.Status = 'Selected'
                        return file;
                    })
                }])
                setFileModal({ ...fileModal, isOpen: false, files: undefined })

            }}>
                <div className="grid grid-cols-1 max-w-[400px] py-2 gap-2  max-h-[600px] overflow-auto p-2">
                    {fileModal.files && fileModal.files.sort((x, a) => {
                        if (x.type > a.type)
                            return -1;
                        if (a.type < x.type)
                            return 1;
                        return 0;
                    }).map((x, i) => {
                        const urlBlob = URL.createObjectURL(x)
                        if (x.type === 'audio/mpeg')
                            return <Audio className="w-96" key={i} fileAddress={urlBlob} fileName={x.name} />
                        else if (x.type === 'image/jpeg')
                            return <Photo key={i} fileName={x.name} fileAddress={urlBlob} />
                        return <File key={i} fileName={x.name} fileAddress={urlBlob} />
                    }).map((x, index) => <div className="flex w-full gap-2" key={index}>
                        <div className="h-full flex justify-center items-center text-danger text-2xl">
                            <Icon icon="rayteb-delete" onClick={() => {
                                const file = fileModal.files![index];
                                const files = fileModal.files!.filter(a => a !== file);
                                setFileModal({ ...fileModal, files: files, isOpen: files.length === 0 ? false : true })
                            }} />
                        </div>
                        {x}

                    </div>)}
                </div>
                <div className="w-full z-10 grid grid-cols-10 justify-items-center items-center mt-3">
                    <div className="col-span-9 w-full">
                        <TextBox className="h-12 !text-sm rounded-none !border-none !outline-none !ring-0  rounded-tr-2xl" debounceTime={0} name="caption" Type={TextBoxTypeEnum.Text} innerText="پیام"

                        />

                    </div>
                    <div className="w-full bg-white flex justify-center items-center col-span-1  rounded-tl-2xl">
                        <Button type="submit" className={`!rounded-full w-12 h-12 !p-2 !bg-white !border-none text-blue-500 col-span-2 ${!isValid && 'text-disable'}`}>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={3} stroke="currentColor" className="w-full h-full transform rotate-180">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5" />
                            </svg>
                        </Button>
                    </div>

                </div>
            </RaytebForm>

        </RaytebModal> */}
    </>
}

Chat.Layout = function ({ children }) {
    return <>{children}</>
}

const HandleValidation = (state: ValidationType[] | undefined, setState: React.Dispatch<React.SetStateAction<ValidationType[] | undefined>>, data: any) => {
    if (state) {
        const newState = [...state].filter(item => {
            if (item.event === ValidationEventEnum.FirstMessage && item.type === ValidationTypeEnum.MinLength) {
                const dataEvent = data as { users: Array<UserChatMessageViewModel>, userId: string }
                const user = dataEvent.users.filter(x => x.senderId === dataEvent.userId)[0]
                if (user) {
                    return
                }
                else {
                    item.isPass = false
                    return item
                }
            }
            return item
        })
        setState(newState)
    }
}
const GetComponentValidation: React.FC<{ props: any, param?: ValidationType, validations?: ValidationType[], setState: React.Dispatch<React.SetStateAction<ValidationType[] | undefined>> }> = ({
    props,
    param,
    setState,
    validations
}) => {
    const inValidMinLength = param?.event === ValidationEventEnum.FirstMessage && param?.type === ValidationTypeEnum.MinLength && parseInt(param.value) > props.length;
    if (validations && param) {
        if (!inValidMinLength) {
            const newValid = [...validations]
            newValid[0].isPass = true
            setState(newValid)
        }
        else if (param.isPass) {
            const newValid = [...validations]
            newValid[0].isPass = false
            setState(newValid)
        }
    }

    if (inValidMinLength)
        return <div className="flex justify-between items-center w-full bg-disable border border-secondaryLight rounded-full px-3">
            <p className="text-sm">{`لطفا شرح بیماری خود را در ${param.value} کاراکتر توضیح دهید`.toPersian()}</p>
            <span className="rounded-full p-2">{parseInt(param.value) - props.length}</span>
        </div>
    else
        return <></>
}
type ValidationType = { event: ValidationEventEnum, type: ValidationTypeEnum, value: string, isPass: boolean }
enum ValidationEventEnum {
    FirstMessage = 'FirstMessage'
}
enum ValidationTypeEnum {
    MinLength = 'MinLength'
}

export default Chat;

